import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { Alert, Modal, ModalBody, ModalHeader, Spinner } from 'reactstrap';
import { Button, Col, Icon, Row } from '../../../components/Component';
import TextInput from '../inputs/TextInput';
import ListText from '../text/ListText';
import { tenant_auth_actions_helper } from '../../../actions/actions_helper';
import { fail_add_product_type, loading_add_product_type, reset_add_product_type, success_add_product_type } from '../../../reducers/auth_tenant/add_product_type_Slice';
import { ADD_PRODUCT_TYPE_ERROR_MSG, ADD_PRODUCT_TYPE_SUCCESS_MSG } from '../../../utils/error_success_messages';
import { useSelector } from 'react-redux';
import { CREATE_PRODUCT_TYPES_API } from '../../../api/api_data';
import * as app_consts from "../../../utils/app_consts";
import { messageToast } from '../../../utils/Utils';

const initalState = { product_type: "" };

const AddProductTypeModal = ({
 openModal,
 setOpenModal,
 type,
 modalTitle,
 modalDescription,
 succFunc,
 size,
 accountId,
 openOtherModalFunc,
 tenant_info
}) => {
 const [modal, setModal] = useState(false);
 const [step, setStep] = useState(1);
 const [error, setError] = useState("");
 const [loading, setLoading] = useState(false);
 const [formData, setFormData] = useState(initalState);

 const dispatch = useDispatch();

 useEffect(() => {
  setError("");
  setFormData(initalState);
  setModal(openModal);
 }, [openModal]);

 const toggleModal = () => {
  setOpenModal(!modal);
 };
 // Handle Change Function
 const handleChange = (e) => {
  setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 const handlePreview = () => {
  setError("");
  setStep(2);
 };

 const handleSubmit = () => {
  setError("");
  // Dispatch
  dispatch(tenant_auth_actions_helper(loading_add_product_type, success_add_product_type, fail_add_product_type, ADD_PRODUCT_TYPE_ERROR_MSG, ADD_PRODUCT_TYPE_SUCCESS_MSG, app_consts.POST, `/${tenant_info?.url_prefix}/${CREATE_PRODUCT_TYPES_API}`, formData));
 };
 // Listen
 const add_product_type_listener = useSelector((state) => state.add_product_type.add_product_type);

 useEffect(() => {
  if (add_product_type_listener.status !== app_consts.IDLE)
  {
   if (add_product_type_listener.status === app_consts.LOADING)
   {
    setLoading(true);
    setError("");
   } else
   {
    setLoading(false);
    if (add_product_type_listener.status === app_consts.FAIL)
    {
     setError(add_product_type_listener.message, app_consts.FAIL);
     messageToast(add_product_type_listener.message, app_consts.FAIL);
    } else if (add_product_type_listener.status === app_consts.SUCCESS)
    {
     succFunc();
     toggleModal();
    }
    dispatch(reset_add_product_type());
   }
  }
 }, [add_product_type_listener]);


 return (
  <>
   <Modal
    isOpen={modal}
    // toggle={!modalLoading ? toggleModal : ""}
    className="modal-dialog-centered"
    size={size ? size : "lg"}
   >
    <ModalHeader toggle={!loading ? toggleModal : ""}>{modalTitle}</ModalHeader>
    <ModalBody>
     <div className="d-flex justify-content-between mb-2">
      <h5 className="card-title text-center w-100">Add Product Type Form</h5>
     </div>{step === 2 && (
      <div
       className="nk-block-head-sub mb-2"
       style={{ cursor: "pointer" }}
       onClick={(e) => {
        e.preventDefault();
        setStep(1);
        setFormData({ ...formData, ["product_type"]: "" });
       }}
      >
       <Icon name="arrow-left" />
       <span>back</span>
      </div>
     )}
     {error && (
      <div className="mb-3 w-100">
       <Alert color="danger" className="alert-icon">
        <Icon name="alert-circle" /> {error}{" "}
       </Alert>
      </div>
     )}
     {step === 1 ? (
      <>
       <form
        onSubmit={(e) => {
         e.preventDefault();
        }}
       >
        <Row className="g-4">
         <TextInput
          label="Product Type"
          required
          type="text"
          id_val="product_type"
          value={formData.product_type}
          colSize="12"
          name="product_type"
          handleChange={handleChange}
         />
         <Col xl="12" className="d-flex justify-content-end">
          <Button
           onClick={handlePreview}
           size="lg"
           type="submit"
           color="primary"
           disabled={
            loading ? loading : !(formData?.product_type)
           }
          >
           Preview and Add Product Type
          </Button>
         </Col>
        </Row>
       </form>
      </>
     )
      :
      <>
       <ListText dataItem="data-item mySmall" label="Product Type" value={formData.product_type} />
       <Col xl="12" className="d-flex justify-content-end mt-2 mr-2">
        <Button onClick={handleSubmit} disabled={loading} color="primary">
         {loading ? <Spinner size="sm" color="light" /> : "Add Product Type"}
        </Button>
       </Col>
      </>
     }
    </ModalBody>
   </Modal>
  </>
 );
};

export default AddProductTypeModal;